<template>
  <el-dialog
    title="员工"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <div class="search-container mb-10">
      <el-input
        v-model="searchForm.staffName"
        placeholder="输入员工名称"
        style="width: 300px"
        clearable
      ></el-input>
      <el-button 
        type="primary" 
        @click="handleSearch"
        style="margin-left: 10px"
      >查询</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="userId"
        label="员工编号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="员工名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="员工地址"
        align="center"
      ></el-table-column>
    </el-table>

    <el-pagination
      class="mt-10"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getNoRoleStaffs, saveRoleStaff } from '@/api/frame/roleStaffApi'

export default {
  name: 'AddRoleStaff',
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        staffName: ''
      },
      tableData: [],
      selectedStaffs: [],
      formData: {
        roleId: '',
        staffs: []
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.formData.roleId = params.roleId
      this.dialogVisible = true
      this.loadStaffs()
    },
    async loadStaffs() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          userName: this.searchForm.staffName,
          roleId: this.formData.roleId
        }
        const res = await getNoRoleStaffs(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取员工列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadStaffs()
    },
    handleSelectionChange(val) {
      this.selectedStaffs = val
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadStaffs()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadStaffs()
    },
    async handleSubmit() {
      if (this.selectedStaffs.length === 0) {
        this.$message.warning('请选择员工')
        return
      }

      try {
        const params = {
          roleId: this.formData.roleId,
          staffs: this.selectedStaffs.map(item => ({
            staffId: item.userId,
            staffName: item.name
          }))
        }
        const res = await saveRoleStaff(params)
        if (res.code === 0) {
          this.$message.success('关联成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('关联员工失败:', error)
        this.$message.error('关联员工失败')
      }
    },
    handleClose() {
      this.searchForm.staffName = ''
      this.selectedStaffs = []
      this.pagination.currentPage = 1
    }
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  align-items: center;
}
.mb-10 {
  margin-bottom: 10px;
}
.mt-10 {
  margin-top: 10px;
}
</style>